import React from 'react';
import PropTypes from 'prop-types';
import Donut from '../Donut';

var PieChart = function PieChart(props) {
  var data = props.data,
      colors = props.colors,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      customLabel = props.customLabel;
  return /*#__PURE__*/React.createElement(Donut, {
    data: data,
    colors: colors,
    customLabel: customLabel,
    outerRadius: 99,
    className: className,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onClick: onClick
  });
};

PieChart.propTypes = {
  /** array of color values */
  colors: PropTypes.array,
  className: PropTypes.string,

  /** function label for donut chart */
  customLabel: PropTypes.func,

  /** array of json data */
  data: PropTypes.array,

  /** is triggered on onMouseOut */
  onBlur: PropTypes.func,

  /** is triggered on onMouseOver */
  onFocus: PropTypes.func,

  /** is triggered when chart is clicked */
  onClick: PropTypes.func,

  /** is triggered when key is pressed */
  onKeyDown: PropTypes.func
};
PieChart.defaultProps = {
  colors: []
};
PieChart.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PieChart",
  "props": {
    "colors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "array of color values"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "customLabel": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function label for donut chart"
    },
    "data": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "array of json data"
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered on onMouseOut"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered on onMouseOver"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered when chart is clicked"
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered when key is pressed"
    }
  }
};
export default PieChart;